<template>
  <div>
    <az-back-button :route="{name: 'licitacao', params: {id: licitacaoId}, query: {edicao: true}}" text="Voltar para a licitação"></az-back-button>
    <br>
    <iframe class="iframe-edocs" :src="srcFlowbeeEdocs"> </iframe>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'edocs',
  components: {
  },
  data() {
    return {
      licitacaoId: this.$route.params.id,
    }
  },
  computed: {
    ...mapState(['licitacao']),
    srcFlowbeeEdocs() {
      return this.montarSrcFlowbeeEdocs()
    }
  },
  async mounted() {
    this.licitacaoId = this.$route.params.id
  },
  methods: {
    montarSrcFlowbeeEdocs(){
      return `/flowbee/#/processos/${this.licitacao.processoVirtual}/sincronizacao/e-docs`
    }
  }
}
</script>
<style lang="stylus">
.icone-fechar-mensagem-erro
  color white !important
  height 24px

.mensagem-erro-juntar
  margin-top 5px
  border 4px solid red
  border-radius 10px
  color: white

.chip-documento-erro
  background-color: white !important
.chip-documento-erro:after
  color: white

html
  scroll-behavior smooth

.tooltip-erro-documento
  opacity: 1 !important

.iframe-edocs {
  width: 100%;
  height: 80vh;
  border: none;
}


</style>
